import React from 'react';

const EditProfileIcon = ({ className}) => (
    <svg width="9" height="9" className={className} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9 4.37592V8.57143H0V0.180405H4.5V1.01951H0.900003V7.73233H8.1V4.37592H9ZM3.15 4.50598L6.7599 1.13363L7.45919 1.98993L3.80655 5.63457H3.15V4.50598ZM2.25 6.47367H4.1922L8.65035 1.99077L6.7842 0L2.25 4.15188V6.47367Z" fill="black"/>
    </svg>





);

export default EditProfileIcon;





